import { useState } from "react";
import AddHackathon from "./AddHackathon";
import EditHackathons from "./EditHackathons";
import Navbar from "../components/Navbar";

const ManageHackathonsPanel = () => {
  const [view, setView] = useState("add");

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="page-container">
        <div className="mb-8">
          <h1 className="section-title">Manage Hackathons</h1>
          <p className="text-gray-500 mt-1">Add or edit hackathon listings.</p>
        </div>

        <div className="flex gap-2 mb-6">
          <button
            onClick={() => setView("add")}
            className={`button text-sm ${view === "add" ? "btn-primary" : "btn-secondary"}`}
          >
            Add New
          </button>
          <button
            onClick={() => setView("edit")}
            className={`button text-sm ${view === "edit" ? "btn-primary" : "btn-secondary"}`}
          >
            Edit Existing
          </button>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 p-6">
          {view === "add" && <AddHackathon />}
          {view === "edit" && <EditHackathons />}
        </div>
      </div>
    </div>
  );
};

export default ManageHackathonsPanel;
